import { render, staticRenderFns } from "./ModalAgregarUsuario.vue?vue&type=template&id=65ec4b8c&scoped=true"
import script from "./ModalAgregarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalAgregarUsuario.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarUsuario.vue?vue&type=style&index=0&id=65ec4b8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec4b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ec4b8c')) {
      api.createRecord('65ec4b8c', component.options)
    } else {
      api.reload('65ec4b8c', component.options)
    }
    module.hot.accept("./ModalAgregarUsuario.vue?vue&type=template&id=65ec4b8c&scoped=true", function () {
      api.rerender('65ec4b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/permisos/ModalAgregarUsuario.vue"
export default component.exports